import * as Types from '../../../../packages/graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type MemberContextDataQueryVariables = {};


export type MemberContextDataQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'products'>
    & { logins: Array<(
      { __typename: 'Login' }
      & Pick<Types.Login, 'claimable'>
    )>, organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Types.Organization, 'premiumFeatures' | 'products'>
    )> }
  )> }
);


export const MemberContextDataDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberContextData"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premiumFeatures"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]}]}}]}}]};

/**
 * __useMemberContextDataQuery__
 *
 * To run a query within a React component, call `useMemberContextDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberContextDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberContextDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberContextDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MemberContextDataQuery, MemberContextDataQueryVariables>) {
        return ApolloReactHooks.useQuery<MemberContextDataQuery, MemberContextDataQueryVariables>(MemberContextDataDocument, baseOptions);
      }
export function useMemberContextDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MemberContextDataQuery, MemberContextDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MemberContextDataQuery, MemberContextDataQueryVariables>(MemberContextDataDocument, baseOptions);
        }
export type MemberContextDataQueryHookResult = ReturnType<typeof useMemberContextDataQuery>;
export type MemberContextDataLazyQueryHookResult = ReturnType<typeof useMemberContextDataLazyQuery>;
export type MemberContextDataQueryResult = ApolloReactCommon.QueryResult<MemberContextDataQuery, MemberContextDataQueryVariables>;